import FundraiserBlogCardShimmer from "./fundraiserBlogCardShimmer";

const FundraiserBlogGridShimmer = () => {
  // Create 6 shimmer cards as placeholder
  const shimmerCards = Array.from({ length: 6 }, (_, index) => (
    <FundraiserBlogCardShimmer key={index} />
  ));

  return (
    <div className="lg:mt-[70px] mt-[46px]">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {shimmerCards}
      </div>
    </div>
  );
};

export default FundraiserBlogGridShimmer; 